import { useState } from "react";
import { motion } from "framer-motion";
import { CASE_STUDIES } from "../data/caseStudies";

const STEP = 12;

export default function CaseStudies() {
  const [count, setCount] = useState(STEP);
  const shown = CASE_STUDIES.slice(0, count);
  const remaining = CASE_STUDIES.length - count;

  return (
    <section
      className="w-full bg-[#F5F6FA] px-5 py-16 md:py-24"
      data-testid="casestudies-grid-section"
    >
      <div className="mx-auto max-w-[1280px]">
        <div className="mb-12 text-center md:mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand">
            Client results
          </span>
          <h2 className="mt-3 text-4xl font-black tracking-tight text-brand-ink md:text-5xl">
            Real stores. Real payouts.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-neutral-600">
            Every screenshot below is pulled straight from a real client
            dashboard — {CASE_STUDIES.length} of them.
          </p>
        </div>

        <div className="columns-1 gap-8 sm:columns-2 xl:columns-3">
          {shown.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.05 }}
              transition={{ duration: 0.5 }}
              className="mb-8 break-inside-avoid overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-[0_6px_30px_-12px_rgba(20,20,40,0.15)] transition-shadow duration-300 hover:shadow-[0_12px_44px_-14px_rgba(79,87,214,0.35)]"
              data-testid={`case-study-${i}`}
            >
              {/* Highlighted name header */}
              <div className="flex items-start justify-between gap-3 border-b border-neutral-100 px-6 pb-4 pt-6">
                <div className="min-w-0">
                  <div className="truncate text-xl font-black tracking-tight text-brand-ink">
                    {c.name}
                  </div>
                  <div className="mt-1 text-[13px] font-medium text-neutral-500">
                    {c.sub}
                  </div>
                </div>
                {c.badge && (
                  <span className="shrink-0 rounded-full bg-emerald-50 px-3 py-1 text-xs font-black text-emerald-600 tabular-nums ring-1 ring-emerald-500/20">
                    {c.badge}
                  </span>
                )}
              </div>

              <div className="flex flex-col gap-3 px-6 py-5">
                <div className="flex flex-wrap items-baseline gap-2.5">
                  <span className="text-3xl font-black tracking-tight text-brand tabular-nums">
                    {c.amt}
                  </span>
                  <span className="text-[13px] font-medium text-neutral-500">
                    {c.per}
                  </span>
                </div>
                {c.quote && (
                  <p className="text-sm italic leading-relaxed text-neutral-600">
                    &ldquo;{c.quote}&rdquo;
                  </p>
                )}
              </div>

              <img
                src={c.img}
                alt={`${c.name} sales screenshot`}
                loading="lazy"
                className="block w-full border-t border-neutral-100"
              />
            </motion.div>
          ))}
        </div>

        {remaining > 0 && (
          <div className="mt-12 flex justify-center">
            <button
              onClick={() => setCount((c) => c + STEP * 2)}
              data-testid="casestudies-loadmore"
              className="rounded-full border border-neutral-300 bg-white px-8 py-4 text-sm font-black uppercase tracking-wide text-brand-ink transition-colors duration-200 hover:border-brand hover:text-brand"
            >
              Show more results ({remaining} more)
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
